import './css/styles.scss';

function loggaTextInit() {}

loggaTextInit();
